export default {
	pages: {
		active: 'Active',
		cancelled: 'Cancelled',
		complete: 'Complete',
		'didnt-win': "Didn't win",
		'under-offer': 'Under offer',
	},
};
